// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VH6D","input":"styles_input__32x2b"};